(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxCondition', {
		require: {
			builder: '^^mxConditionsBuilder',
		},
		bindings: {
			condition: '=',
		},
		controller: MxConditionCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-condition-builder/mx-condition.html',
	});

	MxConditionCtrl.$inject = ['mx.internationalization', 'mx.SolutionBuilderAgent.ConditionsBuilder.Enums'];

	function MxConditionCtrl(i18n, ConditionsBuilderEnums) {
		var vm = this;
		var directive = '';
		vm.i18n = i18n.get('solutionBuilderAgent.components.mx-conditions-builder');

		vm.$onInit = function () {
			Object.defineProperty(vm, 'attributes', {
				writable: false,
				enumerable: false,
				value: vm.condition.attributes,
			});

			vm.valueTypes = ConditionsBuilderEnums.ConditionValueTypes;
			var ConditionTypes = ConditionsBuilderEnums.ConditionTypes;

			switch (vm.condition.conditionType) {
				case ConditionTypes.ObjectReference:
					directive = 'mx-condition-object-reference';
					break;
				case ConditionTypes.ObjectReferences:
					directive = 'mx-condition-object-references';
					break;
				case ConditionTypes.EnumerationReference:
					directive = 'mx-condition-enum-reference';
					break;
				case ConditionTypes.Boolean:
					directive = 'mx-condition-boolean';
					break;
				case ConditionTypes.Date:
					directive = 'mx-condition-date';
					break;
				case ConditionTypes.Expression:
					directive = 'mx-condition-expression';
					break;
				case ConditionTypes.Fragment:
					directive = 'mx-condition-string';
					break;

				case ConditionTypes.Number:
					directive = 'mx-condition-number';
					break;

				case ConditionTypes.MultiFragment:
					directive = 'mx-condition-string';
					break;

				default:
					directive = 'mx-condition-string';
					break;
			}

			vm.directive = '<' + directive + ' condition="vm.condition"></' + directive + '>';
		};

		return vm;
	}
})();
